// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page {
  min-height: calc(100vh - 116px);
  padding: 0 8px 40px;
  color: #0f172a;
  font-family: "Manrope-Regular", "Segoe UI", sans-serif;
  text-align: left;
}

.admin-page__header {
  margin-bottom: 24px !important;
}

.admin-page__eyebrow {
  margin: 0 0 6px !important;
  color: #3656a5 !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: .11em;
  line-height: 1.2;
}

.admin-page__header h1 {
  margin: 0;
  color: #0f172a;
  font-size: clamp(26px, 3vw, 32px);
  font-weight: 800;
  letter-spacing: -.035em;
  line-height: 1.12;
}

.admin-page__intro {
  margin: 6px 0 0 !important;
  color: #526079 !important;
  font-size: 13px !important;
  line-height: 1.5;
}

.admin-page__metric {
  min-width: 180px !important;
  min-height: 66px;
  border: 1px solid #263f86;
  border-radius: 14px !important;
  background: linear-gradient(135deg, #263f86, #334f9a) !important;
  box-shadow: 0 10px 24px rgba(38, 63, 134, .18) !important;
}

/* Direct content panels share the same surface treatment as dashboard cards. */
.admin-page > div[style]:not(.admin-page__header):not(.admin-page__metric),
.admin-page__archive-panel {
  border: 1px solid #e1e8f2 !important;
  border-radius: 18px !important;
  background: #fff !important;
  box-shadow: 0 10px 30px rgba(15, 23, 42, .05) !important;
}

.admin-page > div[style] h6 {
  color: #172554 !important;
  font-size: 15px !important;
  font-weight: 800 !important;
}

.admin-page .form-control,
.admin-page .form-select {
  min-height: 44px;
  border-color: #dbe3ef !important;
  border-radius: 10px !important;
  background-color: #fff;
  color: #172033;
}

.admin-page .form-control:focus,
.admin-page .form-select:focus {
  border-color: #3656a5 !important;
  box-shadow: 0 0 0 3px rgba(54, 86, 165, .14) !important;
}

.admin-page .table-responsive {
  border: 1px solid #e4eaf2;
  border-radius: 12px;
}

.admin-page table { margin: 0 !important; }
.admin-page table thead th {
  border-bottom-color: #dfe6ef !important;
  background: #f5f7fb !important;
  color: #475569 !important;
  font-size: 11px !important;
  letter-spacing: .055em !important;
}
.admin-page table tbody tr { transition: background-color .16s ease; }
.admin-page table tbody tr:hover { background: #f8faff; }
.admin-page table tbody tr:last-child td { border-bottom: 0 !important; }

.admin-page .pagination { margin-bottom: 0; }
.admin-page .page-link { color: #263f86; border-color: #dbe3ef; font-size: 12px; font-weight: 700; }
.admin-page .page-link:focus { box-shadow: 0 0 0 3px rgba(54, 86, 165, .14); }

.admin-page__archive-panel { min-height: 260px; padding: 24px; }
.admin-page__archive-panel > .container-fluid { padding: 0; }
.admin-page__archive-panel .row { margin-right: 0 !important; margin-left: 0 !important; }

@media (max-width: 767.98px) {
  .admin-page { padding: 0 0 28px; }
  .admin-page__header > .d-flex { align-items: stretch !important; flex-direction: column; }
  .admin-page__metric { width: 100%; }
  .admin-page > div[style]:not(.admin-page__header):not(.admin-page__metric),
  .admin-page__archive-panel { padding: 18px !important; border-radius: 15px !important; }
}

@media (prefers-reduced-motion: reduce) {
  .admin-page table tbody tr { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/AdminPages.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,gEAAgE;EAChE,yDAAyD;AAC3D;;AAEA,+EAA+E;AAC/E;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB,oBAAoB,EAAE;AAC1C;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA,6BAA6B,sCAAsC,EAAE;AACrE,mCAAmC,mBAAmB,EAAE;AACxD,2CAA2C,2BAA2B,EAAE;;AAExE,0BAA0B,gBAAgB,EAAE;AAC5C,yBAAyB,cAAc,EAAE,qBAAqB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACnG,+BAA+B,4CAA4C,EAAE;;AAE7E,6BAA6B,iBAAiB,EAAE,aAAa,EAAE;AAC/D,gDAAgD,UAAU,EAAE;AAC5D,kCAAkC,0BAA0B,EAAE,yBAAyB,EAAE;;AAEzF;EACE,cAAc,iBAAiB,EAAE;EACjC,gCAAgC,+BAA+B,EAAE,sBAAsB,EAAE;EACzF,sBAAsB,WAAW,EAAE;EACnC;+BAC6B,wBAAwB,EAAE,8BAA8B,EAAE;AACzF;;AAEA;EACE,6BAA6B,gBAAgB,EAAE;AACjD","sourcesContent":[".admin-page {\n  min-height: calc(100vh - 116px);\n  padding: 0 8px 40px;\n  color: #0f172a;\n  font-family: \"Manrope-Regular\", \"Segoe UI\", sans-serif;\n  text-align: left;\n}\n\n.admin-page__header {\n  margin-bottom: 24px !important;\n}\n\n.admin-page__eyebrow {\n  margin: 0 0 6px !important;\n  color: #3656a5 !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  letter-spacing: .11em;\n  line-height: 1.2;\n}\n\n.admin-page__header h1 {\n  margin: 0;\n  color: #0f172a;\n  font-size: clamp(26px, 3vw, 32px);\n  font-weight: 800;\n  letter-spacing: -.035em;\n  line-height: 1.12;\n}\n\n.admin-page__intro {\n  margin: 6px 0 0 !important;\n  color: #526079 !important;\n  font-size: 13px !important;\n  line-height: 1.5;\n}\n\n.admin-page__metric {\n  min-width: 180px !important;\n  min-height: 66px;\n  border: 1px solid #263f86;\n  border-radius: 14px !important;\n  background: linear-gradient(135deg, #263f86, #334f9a) !important;\n  box-shadow: 0 10px 24px rgba(38, 63, 134, .18) !important;\n}\n\n/* Direct content panels share the same surface treatment as dashboard cards. */\n.admin-page > div[style]:not(.admin-page__header):not(.admin-page__metric),\n.admin-page__archive-panel {\n  border: 1px solid #e1e8f2 !important;\n  border-radius: 18px !important;\n  background: #fff !important;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, .05) !important;\n}\n\n.admin-page > div[style] h6 {\n  color: #172554 !important;\n  font-size: 15px !important;\n  font-weight: 800 !important;\n}\n\n.admin-page .form-control,\n.admin-page .form-select {\n  min-height: 44px;\n  border-color: #dbe3ef !important;\n  border-radius: 10px !important;\n  background-color: #fff;\n  color: #172033;\n}\n\n.admin-page .form-control:focus,\n.admin-page .form-select:focus {\n  border-color: #3656a5 !important;\n  box-shadow: 0 0 0 3px rgba(54, 86, 165, .14) !important;\n}\n\n.admin-page .table-responsive {\n  border: 1px solid #e4eaf2;\n  border-radius: 12px;\n}\n\n.admin-page table { margin: 0 !important; }\n.admin-page table thead th {\n  border-bottom-color: #dfe6ef !important;\n  background: #f5f7fb !important;\n  color: #475569 !important;\n  font-size: 11px !important;\n  letter-spacing: .055em !important;\n}\n.admin-page table tbody tr { transition: background-color .16s ease; }\n.admin-page table tbody tr:hover { background: #f8faff; }\n.admin-page table tbody tr:last-child td { border-bottom: 0 !important; }\n\n.admin-page .pagination { margin-bottom: 0; }\n.admin-page .page-link { color: #263f86; border-color: #dbe3ef; font-size: 12px; font-weight: 700; }\n.admin-page .page-link:focus { box-shadow: 0 0 0 3px rgba(54, 86, 165, .14); }\n\n.admin-page__archive-panel { min-height: 260px; padding: 24px; }\n.admin-page__archive-panel > .container-fluid { padding: 0; }\n.admin-page__archive-panel .row { margin-right: 0 !important; margin-left: 0 !important; }\n\n@media (max-width: 767.98px) {\n  .admin-page { padding: 0 0 28px; }\n  .admin-page__header > .d-flex { align-items: stretch !important; flex-direction: column; }\n  .admin-page__metric { width: 100%; }\n  .admin-page > div[style]:not(.admin-page__header):not(.admin-page__metric),\n  .admin-page__archive-panel { padding: 18px !important; border-radius: 15px !important; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-page table tbody tr { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
